import React from 'react';
import { App as CitoMeesterApp } from './src/App';
import { ErrorBoundary } from './src/components/ErrorBoundary';
export function App() {
  return <ErrorBoundary data-id="element-0">
      <CitoMeesterApp data-id="element-1" />
    </ErrorBoundary>;
}